import React from 'react';

import { Box, Skeleton } from '@mui/material';
import { useTheme } from '@mui/material/styles';

interface IStatisticsChartsSkeletonProps {
  /** Day view includes an extra block for the trainings list */
  variant?: 'overview' | 'day';
}

const CHART_SKELETON_HEIGHT = 320;

const StatisticsChartsSkeleton = ({
  variant = 'overview',
}: IStatisticsChartsSkeletonProps) => {
  const theme = useTheme();
  const sectionCount = variant === 'overview' ? 3 : 2;

  return (
    <Box
      display="flex"
      flexDirection="column"
      gap={3}
      width="100%"
      paddingTop={theme.spacing(0.5)}>
      {Array.from({ length: sectionCount }).map((_, index) => (
        <Box
          key={`chart-skeleton-${index}`}
          display="flex"
          flexDirection="column">
          <Skeleton variant="text" width={200} height={28} sx={{ mb: 1 }} />
          <Skeleton
            variant="rounded"
            height={CHART_SKELETON_HEIGHT}
            sx={{ borderRadius: 1 }}
          />
        </Box>
      ))}
      {variant === 'day' && (
        <Box display="flex" flexDirection="column" gap={1}>
          <Skeleton variant="text" width={180} height={28} />
          <Box display="flex" flexDirection="column" gap={0.5}>
            {Array.from({ length: 3 }).map((_, index) => (
              <Skeleton
                key={`training-skeleton-${index}`}
                variant="rounded"
                height={72}
                sx={{ borderRadius: 1 }}
              />
            ))}
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default StatisticsChartsSkeleton;
